import VerticalPage from "@/components/VerticalPage";
import { MEDIA } from "@/lib/content";

export default function Capital() {
  return (
    <VerticalPage
      overline="Moaglee Capital"
      title="Capital. Structured for Outcomes."
      subtitle="Moaglee Capital connects capital requests, private investors, creative finance, sale-leaseback opportunities, and syndication deal flow."
      image={MEDIA.network}
      statement="Moaglee Capital connects capital requests, private investors, creative finance, sale-leasebacks, and syndication deal flow."
      bullets={[
        "Capital requests across asset classes",
        "Private investor & syndication network",
        "Sale-leasebacks and seller-carry structures",
        "Creative finance & private lending",
        "Refinance and recapitalization strategy",
      ]}
      redirectKey="capital"
      redirectLabel="Visit MoagleeCapital.com"
      forms={["capital_request", "investor"]}
      sourcePage="/capital"
    />
  );
}
